import { render, staticRenderFns } from "./activityDetail.vue?vue&type=template&id=8fef5f14&scoped=true"
import script from "./activityDetail.vue?vue&type=script&lang=js"
export * from "./activityDetail.vue?vue&type=script&lang=js"
import style0 from "./activityDetail.vue?vue&type=style&index=0&id=8fef5f14&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fef5f14",
  null
  
)

export default component.exports